export const countries = {
  CA: { iso: 'CA' },
  GB: { iso: 'GB' }
};

export const euCountries = {
  iso: ['GB', 'DE', 'FR']
};
